import { useId, useState } from 'react';
import type { Question } from '../../data/schemas';
import { Dialog } from '../ui/Dialog';
import { GlossaryPopover } from '../ui/GlossaryPopover';

interface QuestionHelpProps {
  question: Question;
}

/** „Mehr dazu“: Popover/Bottom Sheet mit Erklärung, Hinweisen, Beispielen und Glossar (FR-TEST-003). */
export function QuestionHelp({ question }: QuestionHelpProps) {
  const [open, setOpen] = useState(false);
  const titleId = useId();

  return (
    <>
      <button
        type="button"
        className="button button--secondary"
        onClick={() => setOpen(true)}
        data-testid="question-help-trigger"
      >
        Mehr dazu
      </button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        titleId={titleId}
        title={question.title}
        variant="sheet"
      >
        <div className="stack">
          <p>{question.explanation}</p>
          {question.cautions.length > 0 && (
            <div>
              <p>
                <strong>Zu beachten:</strong>
              </p>
              <ul>
                {question.cautions.map((caution) => (
                  <li key={caution}>{caution}</li>
                ))}
              </ul>
            </div>
          )}
          {question.examples.map((example) => (
            <div key={example.heading}>
              <p>
                <strong>{example.heading}</strong>
              </p>
              <ul>
                {example.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
          {question.glossaryTerms.length > 0 && (
            <p>
              Begriffe:{' '}
              {question.glossaryTerms.map((termId, index) => (
                <span key={termId}>
                  {index > 0 && ', '}
                  <GlossaryPopover termId={termId} />
                </span>
              ))}
            </p>
          )}
        </div>
      </Dialog>
    </>
  );
}
